"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Accordion = ({
  children,
  allowMultipleOpened,
  onChange,
  ...otherProps
}) => {
  const [sectionState, setSectionState] = (0, _react.useState)(children.length > 1 ? children.map((child, index) => !!children[index].props.open) : [!!children.props.open]);
  const toggleOpened = (0, _react.useCallback)(index => {
    let newSectionsState = [...sectionState];

    if (!allowMultipleOpened) {
      newSectionsState = newSectionsState.map((section, sectionIndex) => sectionIndex === index && section === false);
    } else {
      newSectionsState[index] = !newSectionsState[index];
    }

    setSectionState(newSectionsState);

    if (onChange) {
      onChange(newSectionsState);
    }
  }, [onChange, setSectionState, sectionState]);

  if (children.length === 1) {
    return /*#__PURE__*/_react.default.cloneElement(children, {
      index: 0,
      open: sectionState[0],
      toggleOpened: () => toggleOpened(0)
    });
  } else {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledAccordion, { ...otherProps,
      children: _react.default.Children.map(children, (child, index) => {
        return /*#__PURE__*/_react.default.cloneElement(child, {
          index,
          open: sectionState[index],
          toggleOpened: () => toggleOpened(index)
        });
      })
    });
  }
};

Accordion.propTypes = {
  allowMultipleOpened: _propTypes.default.bool,
  onChange: _propTypes.default.func
};
Accordion.defaultProps = {
  allowMultipleOpened: true
};
var _default = Accordion;
exports.default = _default;